module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-933-retro-min.25001371.jpg";